// React + Vite entry. ClerkProvider wraps the router so SignedIn / SignedOut
// gates work; everything else is downstream of the router.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { env } from './env.js';
import { AppRouter } from './routes/router.js';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('root element missing from index.html');

createRoot(container).render(
  <StrictMode>
    <ClerkProvider publishableKey={env.clerkPublishableKey} afterSignOutUrl="/sign-in">
      {/*
        Opt into React Router v7 behaviors early so the deprecation warnings
        stop firing in dev and the eventual upgrade to v7 is a no-op:
          • v7_startTransition: state updates wrapped in React.startTransition
            (smoother nav, no behavioral change for our routes)
          • v7_relativeSplatPath: relative path resolution inside splat
            routes — we already use absolute `<Link to="/..." />` everywhere
            and our child routes inside `path="/*"` use absolute child
            strings, so the new behavior matches what we already get.
      */}
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppRouter />
      </BrowserRouter>
    </ClerkProvider>
  </StrictMode>,
);
